export default "__VITE_ASSET__9752850a__"